import { NgModule } from '@angular/core';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { ProfileDetailsComponent } from './profile-details/profile-details.component';
import { SettingsComponent } from './profile-details/settings/settings.component';
import { PrivacyPolicyComponent } from './profile-details/privacy-policy/privacy-policy.component';
import { ImageUploaderComponent } from './dhhp-image-uploader/image-uploader.component';
import { DeleteAccountComponent } from './profile-details/delete-account/delete-account.component';
import { ChangePasswordComponent } from './profile-details/change-password/change-password.component';
import { DialogOverviewComponent } from './dialog-overview-confirmation/dialog-overview-confirmation.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
//import { DhhpButtonModule } from 'dhhp-button';
import {MatDividerModule} from '@angular/material/divider';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatTabsModule} from '@angular/material/tabs';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatCardModule} from '@angular/material/card';
import {MatTableModule} from '@angular/material/table';
import { ConsentPolicyComponent } from './profile-details/consent-policy/consent-policy.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import {MatProgressBarModule} from '@angular/material/progress-bar';
// import { PasswordStrengthBarModule } from 'ng2-password-strength-bar';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module';
import { ClientLibModule } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { PhBhpFeatureComponentsModule } from 'ph-bhp-feature-packages/ph-bhp-feature-components/public_api';

// common libraries


@NgModule({
    declarations: [
        DialogOverviewComponent, ImageUploaderComponent, ConsentPolicyComponent,
        MyProfileComponent, ProfileDetailsComponent, SettingsComponent, PrivacyPolicyComponent, DeleteAccountComponent, ChangePasswordComponent
    ],
    imports: [MatProgressBarModule,
        // PasswordStrengthBarModule,
        MatTabsModule, MatSelectModule, MatCheckboxModule, MatDialogModule, MatCardModule, MatTableModule,
        BrowserAnimationsModule, MatInputModule, MatIconModule, BrowserModule, MatButtonModule, MatDividerModule, MatSlideToggleModule,
        FormsModule, TranslateModule,
        ReactiveFormsModule, HttpClientModule, /*DhhpButtonModule,*/ RouterModule, PopoverModule.forRoot(), PhBhpUiModule, ClientLibModule, PhBhpFeatureComponentsModule
    ],
    exports: [MyProfileComponent, ProfileDetailsComponent, ImageUploaderComponent]
})
export class ProfileModule { }
